import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';

interface CheckboxFieldProps {
  label?: string;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  [key: string]: any;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  label,
  checked = false,
  onChange,
  ...props
}) => {
  return (
    <AntCheckbox
      checked={checked}
      onChange={e => onChange?.(e.target.checked)}
      {...props}
    >
      {label}
    </AntCheckbox>
  );
};
